goog.provide("shadow.js.shim.module$$mui$icons_material$List");
goog.provide("module$shadow_js_shim_module$$mui$icons_material$List");
shadow.js.shim.module$$mui$icons_material$List = shadow.js.nativeProvides["@mui/icons-material/List"] = shadow$bridge("@mui/icons-material/List");
module$shadow_js_shim_module$$mui$icons_material$List.default = shadow.js.shim.module$$mui$icons_material$List;
